import { sizes } from './sizes';

export const borders = Object.keys(sizes).reduce((acc, value) => {
  return { ...acc, [value]: `${sizes[value as keyof typeof sizes]} solid` };
}, {});
